import { Step, StepLabel, Stepper } from "@mui/material"
import React, { useContext } from "react"
import { customPalette } from "../../../../theme"
import { AppNavBarContext } from "../../../core/context/nav-bar/AppNavBarContext"
import "../app-navbar-v2.scss"

interface IProps {
  steps: string[]
}

export function StepHeader({ steps }: Readonly<IProps>): React.JSX.Element {
  const { stepHeader } = useContext(AppNavBarContext)

  return (
    <Stepper
      alternativeLabel
      activeStep={stepHeader}
      sx={{
        m: 1,
        width: "100%",
        "& .MuiStepConnector-line": {
          borderColor: customPalette.lightGray1,
          borderWidth: 4,
          m: 0,
        },
        [`& .MuiStepConnector-lineHorizontal`]: {
          borderColor: customPalette.lightGray1, // Grey by default
        },
        [`& .Mui-completed .MuiStepConnector-line`]: {
          borderColor: customPalette.mainGreen5, // Green if step is completed
        },
        [`& .Mui-active .MuiStepConnector-line`]: {
          borderColor: customPalette.mainGreen5, // Green if step is active
        },
      }}>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel
            sx={{
              textAlign: "center",
              "& .MuiSvgIcon-root ": {
                textAlign: "center",
                color: "#FFFFFF61",
                border: 1,
                p: "2px",
                borderRadius: "50px",
                m: 0,
              },
              "& .MuiSvgIcon-root.Mui-active": { textAlign: "center", color: customPalette.mainGreen5 },
              "& .MuiSvgIcon-root.Mui-completed": {
                textAlign: "center",
                color: customPalette.mainGreen5,
              },
              "& .MuiStepLabel-label": { textAlign: "center", color: "#FFFFFF61" },
              "& .MuiStepLabel-label.Mui-completed": { textAlign: "center", color: "#FFFFFF61" },
              "& .MuiStepLabel-label.Mui-active": { textAlign: "center", color: customPalette.white },
            }}>
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
